<!--
————————————————————————————————————————————————————————————————————————————————
—                                 TEMPLATE                                     —
————————————————————————————————————————————————————————————————————————————————
-->
<template>
  <div>
    <h1>{{ msg }}</h1>
    <button v-on:click="sayHello" class="btn btn-primary">Sweetalert!</button>
  </div>
</template>

<!--
————————————————————————————————————————————————————————————————————————————————
—                                 SCRIPTS                                      —
————————————————————————————————————————————————————————————————————————————————
-->
<script>
import sweetalert from 'sweetalert'

export default {
  name: 'button-click',
  data () {
    return {
      msg: 'Componant Sweetalert',
      name: 'this.name'
    }
  },
  methods: {
    sayHello: function () {
      sweetalert('Good job!', 'You clicked the button!', 'success')
    }
  }
}
</script>

<!--
————————————————————————————————————————————————————————————————————————————————
—                                  STYLES                                      —
————————————————————————————————————————————————————————————————————————————————
-->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// sweetalert-button.vue?37202f99